<template>
    <div class="related-data">
        <li class="product-item" v-for="(item,index) in productList" :key="index">
            <router-link :to="{path:'/s-mart/application/'+item.app_id+'/detail'}" target="_blank">
              <div class="product-detail">
                <div class="product-left">
                  <img :src="item.feature_logo" alt="">
                </div>
                <div class="product-right">
                  <div class="right-title">{{item.nick_name}}</div>
                  <div class="right-attention">
                    <el-rate
                      class="star-rate"
                      v-model="item.star"
                      :disabled="true"
                      void-icon-class="el-icon-star-on"
                      disabled-void-color="#c4c6cc"
                      :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                    </el-rate>
                    <span class="icon">
                      <el-tooltip class="item" effect="dark" :content="item.fan_num ? '取消收藏' : '添加收藏'" placement="top">
                        <i :class="['bk-icon icon-heart', {'icon-heart-shape': item.fan_num}]"></i>
                      </el-tooltip>
                      {{item.fan_num}}
                    </span>
                    <span class="icon">
                      <i class="bk-icon icon-download"></i>{{item.download_num}}
                    </span>
                  </div>
                </div>
                <img v-if="item.money_type==3" class="inquiry" src="../../images/application_detail/inquiry.png">
              </div>
              <div class="product-desc">
                <span v-html="item.tip"></span>
              </div>
              <div class="product-footer">
                <img class="blue-whale-logo" src="../../images/application_detail/blue-whale-logo.png" alt="">
                <div>
                  <span>当前版本 : </span>
                  <span>V1.0.0</span>
                </div>
                <div>
                  <span>更新时间 : </span>
                  <span>2020-01-31</span>
                </div>
              </div>
            </router-link>
          </li>
    </div>
</template>

<script>
export default {
    data () {
        return {
            productList: [
                {   
                    app_id: 11,
                    app_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/8888-ae9465a1257dc16446c29ff55dd9fd7b.png",
                    app_name: "Windows磁盘清理脚本",
                    download_num: 2,
                    fan_num: 1,
                    feature_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/ps_285x160-64d3f71053d4987fd8f47b6ada576982.png",
                    money_type: 0,
                    nick_name: "蓝鲸智云",
                    online_status: "is_publish",
                    price: 0,
                    star: 5,
                    support: "无任何服务支持",
                    sys_type: "脚本工具",
                    tip: "通过该脚本可以自助删除windows指定目录下的文件...",
                    update_at: "2017-04-15 21:24:02",
                    user_logo: "https://smartpublic-10032816.file.myqcloud.com/custom/1/%E8%93%9D%E9%B2%B8%E5%A4%B4%E5%83%8F_%E5%BD%A9%E8%89%B2-%E7%AB%96.png?1617252900",
                    user_name: "bk",
                },
                {   
                    app_id: 11,
                    app_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/8888-ae9465a1257dc16446c29ff55dd9fd7b.png",
                    app_name: "Windows磁盘清理脚本",
                    download_num: 2,
                    fan_num: 1,
                    feature_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/ps_285x160-64d3f71053d4987fd8f47b6ada576982.png",
                    money_type: 0,
                    nick_name: "蓝鲸智云",
                    online_status: "is_publish",
                    price: 0,
                    star: 5,
                    support: "无任何服务支持",
                    sys_type: "脚本工具",
                    tip: "通过该脚本可以自助删除windows指定目录下的文件...",
                    update_at: "2017-04-15 21:24:02",
                    user_logo: "https://smartpublic-10032816.file.myqcloud.com/custom/1/%E8%93%9D%E9%B2%B8%E5%A4%B4%E5%83%8F_%E5%BD%A9%E8%89%B2-%E7%AB%96.png?1617252900",
                    user_name: "bk",
                },
                {   
                    app_id: 11,
                    app_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/8888-ae9465a1257dc16446c29ff55dd9fd7b.png",
                    app_name: "Windows磁盘清理脚本",
                    download_num: 2,
                    fan_num: 1,
                    feature_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/ps_285x160-64d3f71053d4987fd8f47b6ada576982.png",
                    money_type: 0,
                    nick_name: "蓝鲸智云",
                    online_status: "is_publish",
                    price: 0,
                    star: 5,
                    support: "无任何服务支持",
                    sys_type: "脚本工具",
                    tip: "通过该脚本可以自助删除windows指定目录下的文件...",
                    update_at: "2017-04-15 21:24:02",
                    user_logo: "https://smartpublic-10032816.file.myqcloud.com/custom/1/%E8%93%9D%E9%B2%B8%E5%A4%B4%E5%83%8F_%E5%BD%A9%E8%89%B2-%E7%AB%96.png?1617252900",
                    user_name: "bk",
                },
                {   
                    app_id: 11,
                    app_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/8888-ae9465a1257dc16446c29ff55dd9fd7b.png",
                    app_name: "Windows磁盘清理脚本",
                    download_num: 2,
                    fan_num: 1,
                    feature_logo: "https://smartpublic-10032816.file.myqcloud.com/logo/1/11/ps_285x160-64d3f71053d4987fd8f47b6ada576982.png",
                    money_type: 0,
                    nick_name: "蓝鲸智云",
                    online_status: "is_publish",
                    price: 0,
                    star: 5,
                    support: "无任何服务支持",
                    sys_type: "脚本工具",
                    tip: "通过该脚本可以自助删除windows指定目录下的文件...",
                    update_at: "2017-04-15 21:24:02",
                    user_logo: "https://smartpublic-10032816.file.myqcloud.com/custom/1/%E8%93%9D%E9%B2%B8%E5%A4%B4%E5%83%8F_%E5%BD%A9%E8%89%B2-%E7%AB%96.png?1617252900",
                    user_name: "bk",
                }
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
    .related-data {
        width: 1180;
        margin: 0 auto 25px;
        .product-item:nth-child(3n) {
            margin-right: 0;
        }
        display: flex;
        flex-wrap: wrap;
        .product-item {
            width: 382px;
            height: 231px;
            position: relative;
            font-size: 12px;
            background: #fff;
            border-radius: 2px;
            margin: 0 16px 16px 0;
            box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10); 
            cursor: pointer;
            .product-detail {
                position: relative;
                display: flex;
                align-items: center;
                padding: 22px 16px 18px;
                margin-top: 0;
                .product-left {
                    width: 56px;
                    height: 56px;
                    background: #f0f1f5;
                    border-radius: 8px;
                    padding: 6px;
                    margin-right: 16px;
                    img {
                    height: 100%;
                    width: 100%;
                    border-radius: 6px;
                    }
                }
                .product-right {
                    flex: 1;
                    .right-title {
                        font-weight: 700;
                        font-size: 16px;
                        color: #313238;
                        margin-bottom: 5px;
                    }
                    .right-attention {
                        display: flex;
                        align-items: center;
                        .star-rate {
                            height: auto;
                        }
                    }
                    .default-icon {
                        color: #c4c6cc;
                        font-size: 16px;
                    }
                    .checked {
                        color: #fe9c00;
                    }
                    .icon {
                        display: flex;
                        margin-left: 49px;
                        font-size: 12px;
                        color: #4f515e;
                        position: relative;
                        .bk-icon {
                            display: inline-block;
                            margin-right: 6px;
                            &.icon-download {
                                width: 14px;
                                height: 12px;
                                background: url(../../images/application_detail/icon-download3.png) no-repeat;
                            }
                        }
                        .icon-heart {
                            width: 15px;
                            height: 15px;
                            top: 1px;
                            background: url(../../images/application_detail/icon-heart2.png) no-repeat;
                            background-size: 100% 100%;
                            &:hover {
                                background: url(../../images/application_detail/icon-heart3.png) no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                        .icon-heart-shape {
                            background: url(../../images/application_detail/icon-heart3.png) no-repeat;
                            background-size: 100% 100%;
                        }
                        &:last-child {
                            margin-left: 36px;
                        }
                    }
                }
                .inquiry {
                    position: absolute;
                    top: -2px;
                    left: -4px;
                    height: 51px;
                    width: 54px;
                }
            }
            .product-desc {
                padding: 0 16px;
                color: #63656e;
                line-height: 23px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }
            .product-footer {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 39px;
                border-top: 1px solid #f0f1f5;
                color: #979ba5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 21px;
                .blue-whale-logo {
                    width: 53px;
                    height: 14px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// related_data.vue?bfc7ba34